import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityRole } from '../../../domain/user.model';

@Pipe({
    name: 'roleLabel'
})
export class RoleLabelPipe implements PipeTransform {

    constructor(private translationService: TranslateService) {
    }

    transform(value: EntityRole): string {
        switch (value) {
            case EntityRole.AGENT:
                return 'LABEL.ROLE.AGENT';
            case EntityRole.WORKER:
                return 'LABEL.ROLE.WORKER';
            case EntityRole.DIRECT_SALES:
                return 'LABEL.ROLE.DIRECT_SALES';
            case EntityRole.SALES_MANAGER:
                return 'LABEL.ROLE.SALES_MANAGER';
            case EntityRole.HEADQUATERS:
                return 'LABEL.ROLE.HEADQUATERS';
            default:
                return '';
        }

    }
}
